import React from 'react'

/**
 * @param table
 * @param isOwnTurn
 * @param send
 */
class HealthSelection extends React.Component
{

    renderOption(bid, iconUrl, text, onClick)
    {
        return (
            <div
                key={ text }
                onClick={ this.props.isOwnTurn ? onClick : undefined } 
                className={ "dk-button " + (bid === "HEALTHY" ? "special" : "") }>
                <img src={ iconUrl }></img>
                { text }
            </div>
        )
    }

    handleSelectBid(bid)
    {
        const send = () => this.props.send({ type: "SELECT_BID", bid: bid })
        if (bid === "FLESHLESS") {
            getDialog().show({
                content: Messages("game.fleshless.warning"),
                buttons: [
                    { text: Messages("game.fleshless.warning.decline") },
                    { text: Messages("game.fleshless.warning.accept"), onClick: send }
                ]
            })
        } else {
            send()
        }
    }

    getBidImageURL(bid)
    {
        let name
        switch(bid)
        {
        case "HEALTHY": name = "healthy"; break;
        case "CLUBS_SOLO": name = "solo_clubs"; break;
        case "SPADES_SOLO": name = "solo_spades"; break;
        case "HEARTS_SOLO": name = "solo_hearts"; break;
        case "DIAMONDS_SOLO": name = "solo_diamonds"; break;
        case "QUEENS_SOLO": name = "solo_queens"; break;
        case "JACKS_SOLO": name = "solo_jacks"; break;
        case "FLESHLESS": name = "solo_fleshless"; break;
        case "POVERTY": name = "poverty"; break;
        case "THROW": name = "throw"; break;
        case "MARRIAGE_FIRST":
        case "MARRIAGE_SECOND": name = "marriage"; break;
        }
        return "/assets/images/" + name + ".png"
    }

    render()
    {

        let options = {
            "SOLO": this.props.table.get("possibleBids")
                .filter(bid => [ "CLUBS_SOLO", "HEARTS_SOLO", "DIAMONDS_SOLO",
                    "SPADES_SOLO", "QUEENS_SOLO", "JACKS_SOLO", "FLESHLESS" ].includes(bid))
        }

        options["STANDARD"] = this.props.table.get("possibleBids").filter(bid => !options["SOLO"].includes(bid))

        Object.keys(options).forEach(key => {
            options[key] = options[key].map(bid => this.renderOption(
                bid,
                this.getBidImageURL(bid),
                Messages("game.bid." + bid.toLowerCase().replace(/_/g, "-")),
                () => this.handleSelectBid(bid)
            ))
        })

        let optionSections = ["STANDARD", "SOLO"].filter(key => !!options[key].size)
            .map(key => {
                return (
                    <div key={ key } className="section">
                        <div className="section-heading">
                            { Messages("game.bid.category-" + key.toLowerCase()) }
                        </div>
                        <div className="buttons">
                            { options[key] }
                        </div>
                    </div>
                )
            })

        const table = this.props.table
        const playerSelf = table.get("players").find(p => p && p.get("id") == table.get("ownId"))
        let bid = playerSelf ? playerSelf.get("bid") : null
        if (bid === "NONE") {
            bid = null
        }

        let content = bid ? (
            <div className="selected-bid">
                <img src={ this.getBidImageURL(bid) }  />
                <div>{ Messages("game.bid." + bid.toLowerCase().replace(/_/g, "-")) }</div>
            </div>
        ) : (
            <div className="content">
                { optionSections }
            </div>
        )

        return (
            <div className="center-content">
                <div className={ "health-selection " + ((this.props.isOwnTurn || bid) ? "" : "disabled") }>
                    <div className="health-heading">
                        { Messages("game.bidding.title").toUpperCase() }
                    </div>
                    { content }
                </div>
            </div>
        )
    }

}

export default HealthSelection
export { HealthSelection }